(function () {
  'use strict';

  /* @ngdoc object
   * @name wbDynamicAttributes
   * @description
   *
   */
  angular
    .module('wbDynamicAttributes', [
    ]);
}());
